const keyGenerationModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl:
    '/modules/modals/key-generation-modal/key-generation-modal.html',
  controller: 'KeyGenerationModalController',
};

angular
  .module('modalDirectives')
  .component('keyGenerationModal', keyGenerationModal);
